export default function numericValue(inputValue) {
  return inputValue.replace(/[^\d.]/g, '');
}
